export const articles = [
  {
    id: 1,
    slug: 'dingliu-xiaosheng-beipo-lianai-baoguang',
    title: '顶流小生被曝与95后小花秘恋三年，同居细节大曝光',
    summary: '某顶级流量男星与新生代小花被拍到多次出入同一小区，两人疑似已低调同居三年，粉丝震怒，双方工作室紧急公关。',
    content: `近日，有网友在某高档小区连续拍到顶流小生陈某与95后新晋小花李某多次同进同出，两人不仅共用门禁卡，更被目击一同下楼遛狗、采购生活用品，关系亲密程度远超普通朋友。

据知情人士透露，陈某与李某早在2022年拍摄古装偶像剧《星河落》时就已擦出火花，剧中两人饰演一对历经磨难的恋人，戏外也假戏真做。剧组工作人员爆料称，拍摄期间两人经常在片场窃窃私语，收工后也常常一起离开。

"他们其实早就在一起了，只是双方团队都觉得曝光会影响事业，所以一直压着不让说。"一位接近李某团队的业内人士表示，"陈某那边粉丝基数大，女友粉比例高，曝光恋情对他的商业价值影响很大。"

更劲爆的是，有业主爆料称在该小区电梯里多次遇到两人，而且两人穿着居家服、拖鞋，看起来就是普通情侣的日常状态。"有一次他们一起下楼取外卖，李某还帮陈某整理衣领，特别自然。"

面对汹涌而来的爆料，陈某工作室于今日凌晨发布声明，称"艺人目前单身，与李某仅为普通朋友关系，恳请大家不要过度解读"。然而这份声明被网友发现存在多处漏洞——并未直接否认同居，且措辞模棱两可。

李某方面则始终保持沉默，其粉丝后援会发文呼吁"不信谣不传谣"。但细心的网友扒出，李某近半年社交平台照片背景中的窗帘、地板与陈某在某次直播中露出的居家环境高度相似。

截至目前，该话题已登上微博热搜榜首，阅读量突破8亿，相关讨论仍在持续发酵。`,
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20paparazzi%20photo%20style%2C%20blurred%20silhouette%20walking%20together%20at%20night%20in%20urban%20residential%20area%2C%20warm%20street%20lights%2C%20grainy%20photo%20texture%2C%20mysterious%20atmosphere%2C%20cinematic%20tones%2C%20editorial%20photography&width=800&height=530&seq=article-01&orientation=landscape',
    author: '扒瓜小编',
    date: '2026-07-02',
    readTime: '6分钟',
    views: 125800,
    likes: 3420,
    isHot: true,
    isExclusive: true,
    relatedIds: [2, 5, 8],
  },
  {
    id: 2,
    slug: 'yixian-nvxing-yinhan-fenshou-henliao',
    title: '一线女星隐婚八年被曝离婚，前夫手握"致命录音"索要天价分手费',
    summary: '某一线实力派女星被传已与圈外老公协议离婚，男方 allegedly 掌握大量对女方不利的录音证据，双方律师团队正在激烈博弈。',
    content: `娱乐圈再掀惊涛骇浪！据可靠消息源，实力派一线女星周某与其圈外富豪老公已秘密协议离婚，这场持续八年的婚姻最终以极为难堪的方式收场。

周某，现年38岁，出道二十年，以演技精湛著称，曾三度斩获最佳女主角桂冠。其老公王某为某知名投资机构合伙人，两人于2018年低调完婚，育有一子。多年来，周某在公开场合极少提及家庭生活，被外界视为"低调婚姻"的典范。

然而，知情人士透露，这段婚姻早已名存实亡。"他们分居至少两年了，只是一直没办手续。"该人士称，王某近日突然提出离婚，并掌握了一系列对周某极为不利的录音证据。

据悉，这些录音 allegedly 包括周某在私密场合对圈内同行的大量负面评价、涉及税务操作的敏感对话，以及更为劲爆的个人隐私内容。王某方面要求分割夫妻共同财产的同时，还索要一笔"封口费"，金额高达九位数。

"这已经不是普通的离婚案了，男方手里捏着的东西如果真的曝光，周某的演艺事业可能会受到毁灭性打击。"一位法律界人士分析道。

周某经纪人今日接受媒体采访时表示："艺人的私事我们不便过多评论，但有关'录音''天价分手费'等说法纯属子虚乌有。我们会通过法律途径维护艺人的合法权益。"

值得注意的是，周某近期突然取消了多个公开活动，原定于本月举行的品牌代言发布会也临时延期。其社交账号自上周起停止更新，评论区已涌入大量网友追问婚姻状况。

目前，双方律师团队正在就财产分割和抚养权问题进行激烈谈判，最终结果如何，51扒瓜网将持续关注。`,
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20portrait%20in%20black%20evening%20gown%2C%20dramatic%20studio%20lighting%2C%20serious%20expression%2C%20high%20fashion%20editorial%20photography%2C%20dark%20moody%20background%2C%20sharp%20focus%20on%20face%2C%20luxurious%20atmosphere&width=800&height=530&seq=article-02&orientation=landscape',
    author: '八卦追踪组',
    date: '2026-07-01',
    readTime: '7分钟',
    views: 98700,
    likes: 2150,
    isHot: true,
    isExclusive: false,
    relatedIds: [1, 3, 7],
  },
  {
    id: 3,
    slug: 'wanghong-xiaohua-taoshui-yifang',
    title: '千万粉网红小花被举报偷税漏税，税务局已立案调查',
    summary: '拥有超过1200万粉丝的头部网红林某近日被实名举报涉嫌偷逃税款，主管税务机关已正式立案，其名下关联公司被冻结。',
    content: `税务部门再出重拳！拥有1200万粉丝的头部带货网红林某被实名举报偷逃税款，目前主管税务机关已正式立案调查，其名下三家关联企业账户已被冻结。

林某以"种草"美妆护肤起家，凭借精致的内容制作和频繁的明星合作迅速积累千万粉丝。其单场直播带货GMV曾多次突破千万大关，年收入据传超过亿元。然而，光鲜亮丽的数字背后，却隐藏着不为人知的税务操作。

举报人提供的材料显示，林某自2022年起，通过设立多家空壳公司进行收入拆分，将个人所得转化为企业经营所得，并利用小微企业税收优惠进行大规模逃税。据初步估算，涉案金额可能超过3000万元。

"她的操作手法很常见，但规模很大。"一位税务师分析，"通过关联公司走账、虚构成本费用、转移收入到税收洼地等方式，把本该缴纳45%个人所得税的收入，变成了只缴纳5%企业所得税的成本。"

税务机关于上周对林某名下位于杭州滨江区的办公场所进行了突击检查，带走了大量财务资料。现场目击者称，当时林某并不在场，但其助理面对执法人员时神色慌张。

林某于昨日发布视频回应，称"一直以来都依法纳税，不存在任何违规行为"。然而细心的网友发现，视频中她避重就轻，并未正面回应关联公司的问题。更讽刺的是，就在该视频发布三小时后，相关话题即被微博降热搜。

值得注意的是，林某近期已悄悄下架了多个高单价商品链接，其直播间流量也出现明显下滑。多家与其合作的品牌方开始观望，已有两个原定本月启动的代言合作被搁置。

业内普遍认为，如果偷税金额属实，林某将面临补缴税款、滞纳金及罚款的巨额支出，其商业IP价值也将大打折扣。此前已有数位网红因税务问题彻底退出公众视野的前车之鉴。`,
    category: 'wangluo-redian',
    categoryName: '网络热点',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20female%20influencer%20recording%20video%20content%20in%20modern%20studio%2C%20ring%20light%2C%20professional%20camera%20setup%2C%20cosmetic%20products%20on%20desk%2C%20warm%20bright%20lighting%2C%20behind%20the%20scenes%20style%2C%20editorial%20photography&width=800&height=530&seq=article-03&orientation=landscape',
    author: '热点追踪组',
    date: '2026-07-02',
    readTime: '5分钟',
    views: 87600,
    likes: 1890,
    isHot: true,
    isExclusive: true,
    relatedIds: [2, 6, 9],
  },
  {
    id: 4,
    slug: 'jingxuan-zongyi-baheizha-neimu',
    title: '某S+级综艺被曝黑幕：冠军早已内定，选手签约不平等条约',
    summary: '顶流选秀综艺《星耀未来》被内部工作人员爆料节目存在严重黑幕，决赛排名赛前就已确定，选手被迫签订高额违约金合约。',
    content: `年度最受关注的选秀综艺《星耀未来》正在热播，然而就在决赛前夕，一位自称节目组前工作人员的网友在社交平台发布长文，揭露了节目背后令人震惊的操作内幕。

该网友以详实的细节描述了节目从海选到决赛的"剧本"安排："50强的名单在录制前就已经定好了，所谓的全民投票只是走个过场。"该人士称，节目组通过控制镜头分配、剪辑偏好以及热搜投放，系统性地操纵选手人气走向。

更具爆炸性的是，冠军人选早在三个月前就已敲定。"某大公司已经预定了出道位，从第一期开始就在疯狂给镜头、给故事线。其他选手不过是陪跑的。"该网友还晒出了一张据称是内部会议的截图，显示"最终名次预案"，前三名与目前网络投票结果大相径庭。

而选手方面，多位参赛者被迫签订了一份极为苛刻的经纪约。根据流出的合同条款，选手若中途退赛需支付高达500万元的违约金；出道后前五年所有收入的70%归公司所有；未经公司许可不得私自接任何工作。一位法律专家指出："这种合同明显显失公平，放在法庭上大概率会被判定无效。"

更离谱的是，有选手爆料称自己在比赛期间被节目组要求"配合演出"——即按照导演指示在特定场景表现出特定情绪。"有一次导演直接说'你等会儿要哭，因为下一期要剪成你被排挤的桥段'。"

面对汹涌的质疑声，《星耀未来》节目组今日发布声明，称"所有赛制公平公正，投票数据真实有效，对恶意造谣者将追究法律责任"。然而该声明被网友群嘲为"毫无说服力"，要求其公开投票原始数据。

目前，多个与节目合作的品牌已启动舆情评估，某知名饮品品牌已悄悄撤下了与该节目的联名广告。`,
    category: 'dujia-mengliao',
    categoryName: '独家猛料',
    image: 'https://readdy.ai/api/search-image?query=Television%20talent%20show%20stage%20with%20dramatic%20lighting%2C%20empty%20microphone%20stands%2C%20colorful%20spotlights%2C%20dark%20concert%20atmosphere%2C%20smoke%20effects%2C%20competition%20tension%2C%20cinematic%20wide%20shot&width=800&height=530&seq=article-04&orientation=landscape',
    author: '独家爆料组',
    date: '2026-06-30',
    readTime: '8分钟',
    views: 156000,
    likes: 4560,
    isHot: true,
    isExclusive: true,
    relatedIds: [5, 10, 11],
  },
  {
    id: 5,
    slug: 'danghong-yanyuan-pianchou-xuanan',
    title: '当红男演员片酬过亿背后的洗钱疑云，资金链牵出境外账户',
    summary: '某一线男演员被曝片酬高达1.2亿，其收入流向存在重大疑点，多个收款账户指向离岸金融中心，引发监管部门关注。',
    content: `影视圈片酬问题再起波澜。据审计业内人士爆料，某一线男演员张某2025年度申报片酬收入高达1.2亿元，但通过追踪其资金流向，发现存在严重的洗钱嫌疑。

张某，现年34岁，近两年凭借两部爆款古装剧跻身一线男星行列，商业价值飙升。其片酬从2023年的3000万暴涨至2025年的1.2亿，增幅惊人。然而，有业内人士质疑其真实市场价值是否匹配如此天价。

"他的片酬里有很大的水分。"一位曾与张某合作过的制片人透露，"表面上报的是1.2亿，但实际上通过各种'阴阳合同'、虚假制作费等方式，有很大一部分回流到了幕后资金方手里。"

更令人震惊的是资金流向。税务稽查人员发现，张某片酬中的6000万通过四层空壳公司流转后，最终进入了开曼群岛和英属维尔京群岛的离岸账户。这些账户的实际控制人身份目前仍在追查中。

"这种操作模式非常典型：通过虚增片酬制造大额资金流动，然后利用关联公司层层转移，最终汇入离岸账户洗白。"一位反洗钱专家分析道，"如果查实，不仅涉及逃税，还可能构成洗钱罪。"

张某工作室于昨日晚间发文"辟谣"，称所有收入均依法纳税，资金流向合法合规。但网友发现该声明并未提供任何实质性的证据，评论区已被"拿证据说话"刷屏。

与此同时，张某参演的三部待播剧播出计划受到影响。某视频平台内部人士称，平台法务部门正在评估是否调整播出策略。"如果有涉刑风险，平台不敢贸然播出，万一播完人就进去了，损失太大了。"

目前，相关监管部门已介入调查，最终结果如何，51扒瓜网将持续追踪报道。`,
    category: 'wangluo-redian',
    categoryName: '网络热点',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20film%20set%20backstage%20area%20with%20expensive%20equipment%2C%20director%20chair%2C%20clapperboard%2C%20dramatic%20cinematic%20lighting%2C%20money%20and%20contracts%20scattered%20on%20table%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=530&seq=article-05&orientation=landscape',
    author: '热点追踪组',
    date: '2026-06-29',
    readTime: '6分钟',
    views: 112300,
    likes: 2980,
    isHot: true,
    isExclusive: false,
    relatedIds: [1, 4, 8],
  },
  {
    id: 6,
    slug: 'chaoniu-nvxing-daigou-yiwen',
    title: '超一线女星代孕疑云再起，海外医院就诊记录遭黑客曝光',
    summary: '某超一线女星的海外就诊记录疑似遭黑客窃取并在暗网流传，记录显示其在2024年曾多次前往某知名生殖医疗机构。',
    content: `娱乐圈的"代孕"话题再添猛料！某超一线国际影星的海外医疗记录在暗网被挂出售卖，记录显示其在2024年曾多次出现在美国加州一家知名的辅助生殖医疗机构。

这位女星，现年41岁，出道二十余年，是国际影坛公认的演技派代表，曾获多项国际大奖。她于2020年突然宣布"暂时息影，专注个人生活"，此后三年几乎消失在公众视野。2023年底复出时，身材状态引起不少网友猜测。

泄露的医疗记录显示，该女星在2024年2月、5月和9月三次前往该医疗机构，就诊科室为"Reproductive Endocrinology"（生殖内分泌科）。记录中出现了"surrogate consultation"（代孕咨询）和"embryo transfer"（胚胎移植）等关键词。

"这些记录的真实性非常高。"一位网络安全专家分析，"包含完整的患者编号、就诊时间、科室信息，以及医生的电子签名。如果是伪造的，成本会非常高。"

该女星团队于今日发布措辞强硬的声明，称"已委托律师启动法律程序，对造谣者追究到底"。声明中强调"艺人从未进行任何代孕行为，所有医疗行为均属个人隐私，非法获取和传播者将承担刑事责任"。

然而，声明并未正面解释就诊记录的真实性，引发网友更大猜疑。"如果是假的，为什么不直接说'就诊记录是伪造的'？只是说'未进行代孕行为'，这有玩文字游戏的嫌疑。"

值得注意的是，该女星在2023年复出时曾带着一名约两岁左右的婴儿出现在机场，当时解释是"亲戚家的孩子"。如今回头看，这个解释显得颇为牵强。

代孕在国内属于违法行为，但在美国部分州合法。如果该女星确实通过海外代孕获得子女，虽然不直接违反国内法律，但可能面临舆论和道德层面的巨大压力。此前已有女星因此事导致事业严重受挫的先例。

目前，该女星的多个国际代言合约已进入"观察期"，品牌方密切关注事态发展。`,
    category: 'dujia-mengliao',
    categoryName: '独家猛料',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20medical%20documents%20and%20files%20on%20dark%20desk%2C%20hospital%20cross%20symbol%2C%20confidential%20stamp%2C%20dark%20moody%20lighting%2C%20cybersecurity%20theme%2C%20red%20alert%20glow%2C%20editorial%20photography&width=800&height=530&seq=article-06&orientation=landscape',
    author: '独家爆料组',
    date: '2026-07-02',
    readTime: '7分钟',
    views: 203000,
    likes: 6780,
    isHot: true,
    isExclusive: true,
    relatedIds: [3, 7, 12],
  },
  {
    id: 7,
    slug: 'qingchun-ouxiang-xuexizaojia-shihui',
    title: '清纯人设崩塌！当红偶像学历造假实锤，母校官网查无此人',
    summary: '以"学霸偶像"著称的某男团成员被证实学历造假，其 claimed 的海外名校学历在官方渠道无法查证，清高人设彻底崩塌。',
    content: `又一个"学霸人设"翻车了！以"海外名校硕士""归国高材生"形象吸粉无数的男团成员赵某，其 claimed 的学历背景被证实存在严重造假。

赵某，26岁，是某七人男团的主唱担当，在公开场合多次提及自己"毕业于美国某常春藤盟校传媒专业硕士"。这一标签为其赢得了"娱乐圈稀缺的高学历艺人"称号，粉丝群体中有大量"学历粉"。

然而，一位较真网友通过该校校友查询系统检索赵某姓名，却显示"查无此人"。该网友进一步联系学校注册办公室，对方确认"从未有过名为赵某的毕业生"。消息一出，舆论哗然。

面对质疑，赵某团队最初解释称"可能是系统录入有误""姓名拼写问题"。但网友顺藤摸瓜，发现赵某 claimed 的毕业年份（2021年）正值疫情最严重时期，当时该校大部分课程转为线上，而赵某那段时间的公开行程显示他一直在国内参加综艺录制和商演。

"2021年中美航班几乎熔断，他在国内录了三个综艺，怎么可能同时在美国读书？"一位网友的质疑获得大量转发。

更讽刺的是，赵某曾在某读书类综艺中分享"留学心得"，描述了大量美国校园生活的细节。如今被网友逐条打脸——其描述的图书馆布局、食堂菜单、甚至教授的名字都与该校实际情况不符。

赵某所在男团的经纪公司今日发布道歉声明，称"艺人确实未获得 claimed 的学位，对此深表歉意"。声明中表示将对赵某进行"内部教育和处罚"，并承诺"以后在艺人资料审核上更加严格"。

然而，这样的道歉显然无法平息网友怒火。"他靠着'学霸'人设拿了多少代言？读书综艺、教育类品牌的合作，是不是都算欺诈？"更有网友呼吁受骗的品牌方和节目方追究其法律责任。

截至目前，已有两个教育类品牌宣布终止与赵某的合作，其所在的男团原定下个月启动的世界巡演也面临赞助商撤资的危机。`,
    category: 'wangluo-redian',
    categoryName: '网络热点',
    image: 'https://readdy.ai/api/search-image?query=University%20diploma%20and%20graduation%20cap%20on%20wooden%20desk%2C%20books%20stacked%2C%20warm%20library%20lighting%2C%20scholarly%20atmosphere%2C%20close%20up%20detail%20shot%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=800&height=530&seq=article-07&orientation=landscape',
    author: '热点追踪组',
    date: '2026-06-28',
    readTime: '6分钟',
    views: 167000,
    likes: 5230,
    isHot: true,
    isExclusive: false,
    relatedIds: [2, 6, 10],
  },
  {
    id: 8,
    slug: 'yixian-yanyuan-shoushi-anshi',
    title: '一线女演员被家暴实锤！伤情鉴定报告及报警记录全曝光',
    summary: '实力派女演员吴某遭前夫家暴的证据链完整曝光，包括伤情鉴定报告、报警记录和小区监控，引发全网愤怒声援。',
    content: `#MeToo运动之后，娱乐圈又一位女星勇敢地站了出来。实力派女演员吴某日前通过律师发布声明，正式确认自己长期遭受前夫家暴，并公布了完整的证据链。

吴某，35岁，以端庄大气的形象著称，曾塑造多个深入人心的女性角色。她的前夫孙某为某科技公司高管，两人2019年结婚，2024年协议离婚。当时官方说法是"性格不合和平分手"，如今真相大白。

公布的证据包括：
1. 2023年11月的医院伤情鉴定报告，显示"全身多处软组织挫伤、面部钝器伤、右前臂二度烫伤"；
2. 三次报警记录（2023年3月、8月和11月），其中一次警方出警并做了笔录；
3. 小区电梯监控画面，显示孙某对吴某进行推搡和拖拽；
4. 邻居证人证言，证明多次听到激烈争吵和重物摔落声。

"她（吴某）曾经跟我们求助过，说想离婚但对方不同意，还威胁要曝光她的隐私。"一位吴某的密友透露，"那次烫伤是孙某故意把开水泼在她身上的。"

吴某在长文中写道："我以为隐忍能换来平静，但暴力只会愈演愈烈。今天选择公开，不是为了博取同情，而是希望更多遭受家暴的人敢于说'不'，勇敢寻求帮助。"

文章发布后迅速引爆网络，#心疼吴某# #家暴零容忍# 等话题霸占热搜。超过百位圈内艺人转发声援，妇联也发文表示关注并将提供法律援助。

孙某方面尚未做出任何回应，但其所在公司官网已将其从管理层名单中移除。知情人士称，孙某目前处于"失联状态"。

法律专家指出，如果伤情鉴定和监控证据属实，孙某已涉嫌故意伤害罪和虐待罪，最高可判处三年有期徒刑。而威胁曝光隐私的行为还可能构成敲诈勒索罪。

51扒瓜网将持续关注此案后续进展。`,
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20woman%20sitting%20alone%20by%20window%2C%20dramatic%20side%20lighting%2C%20sad%20atmosphere%2C%20soft%20warm%20tones%2C%20intimate%20emotional%20portrait%2C%20editorial%20photography%20style&width=800&height=530&seq=article-08&orientation=landscape',
    author: '扒瓜小编',
    date: '2026-07-01',
    readTime: '8分钟',
    views: 234000,
    likes: 8900,
    isHot: true,
    isExclusive: false,
    relatedIds: [1, 2, 12],
  },
  {
    id: 9,
    slug: 'dingliu-zuhe-jieti-neizhan',
    title: '顶级男团内部撕逼大战！队长与C位互取关，粉丝站集体关站',
    summary: '国内最火男团"极光少年"内部爆发严重矛盾，队长与C位成员公开互取关，双方粉丝站宣布集体休站，团队面临解散危机。',
    content: `国内顶级男团"极光少年"近日陷入前所未有的内部危机。队长郑某与C位成员刘某在社交平台公开互取关，双方粉丝站更是宣布集体关闭，这场"内讧"已将整个团队推向解散边缘。

极光少年于2021年通过选秀节目成团，七名成员各具特色，出道即登顶，成为近年来最成功的男团之一。然而，表面的团魂满满之下，暗流涌动已久。

矛盾的导火索是资源分配不均。"队长和C位其实在很多事情上都有分歧，只不过以前压着不爆出来。"一位接近团队的业内人士称，"比如品牌代言的站位、综艺镜头的分配、单曲的Part划分，这些琐碎小事积累多了就变成了大事。"

上周，某时尚杂志发布了极光少年的封面大片，封面排版中郑某位于最左侧，而刘某作为C位居中。这本是一次正常的排版，但郑某的粉丝发现内页刘某的个人篇幅远超郑某，随即开撕刘某"越权"。刘某粉丝反击称"C位本来就应该资源最多"。

骂战从粉丝层面迅速升级至正主。郑某和刘某先后取关对方的社交账号，虽然数小时后重新关注，但这一举动已被网友截图保存，成为"不和实锤"。

更严重的是，两家粉丝站宣布"无限期休站"——即停止一切应援活动、数据打榜、商务购买等。对偶像团体而言，粉丝站休站意味着商业价值的断崖式下跌。

极光少年所属公司昨日发布声明，称"团队成员之间关系良好，取关为误操作，请大家不要过度解读"。然而这一解释被网友嘲讽为"把大家当傻子"。

目前，极光少年的七位成员已分成明显的小团体活动，合体行程大幅减少。原定下个月发行的团体专辑也传出"改为个人EP合集"的消息。

"解散可能只是时间问题。"一位资深娱乐评论人判断，"内娱男团的寿命本来就不长，内部矛盾加速了这个过程。"

51扒瓜网将持续关注极光少年的最新动态。`,
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20men%20standing%20apart%20in%20tension%2C%20stylish%20kpop%20fashion%2C%20dramatic%20stage%20lighting%2C%20division%20and%20conflict%20atmosphere%2C%20dark%20background%2C%20editorial%20group%20portrait&width=800&height=530&seq=article-09&orientation=landscape',
    author: '扒瓜小编',
    date: '2026-06-30',
    readTime: '6分钟',
    views: 189000,
    likes: 4320,
    isHot: true,
    isExclusive: false,
    relatedIds: [4, 10, 11],
  },
  {
    id: 10,
    slug: 'zhiming-daoyan-qianquan-xingsaorao',
    title: '知名导演被多名女演员联名举报性骚扰，聊天记录极其露骨',
    summary: '曾获国际大奖的资深导演王某被三名女演员联名实名举报长期性骚扰，附带的聊天记录不堪入目，电影局已介入调查。',
    content: `电影圈再爆惊天丑闻！曾获柏林电影节银熊奖的资深导演王某被三位女演员联名实名举报性骚扰，举报材料中包含大量露骨的聊天记录和不堪回首的细节描述。

王某，62岁，执导过十余部获奖影片，被誉为"第五代导演中的良心"。然而，三位年轻女演员的勇敢发声，撕下了这位"艺术大师"的伪善面具。

第一位举报人演员林某称，2023年在王某执导的电影中担任女配角期间，多次遭到王某的言语和肢体骚扰。"他经常以'讲戏'为由把我叫到酒店房间，有一次甚至试图强行拥抱我。"

林某公开的聊天记录中，王某发送了大量带有性暗示的内容，包括"今晚来我房间，我给你加戏""你穿那条裙子真性感，想不想当女主角"等。更有甚者，王某曾直接向林某发送自己的私密照片。

第二位举报人演员陈某的遭遇更为恶劣。她称在2022年某部电影选角过程中，王某以"试戏"为名要求她表演大尺度桥段，并在试戏过程中对她进行了不当身体接触。"他说这是'斯坦尼斯拉夫斯基体系'，要解放天性。"

第三位举报人演员郑某虽然没有与王某直接合作过，但提供了王某在2024年某电影节期间对其发送的骚扰信息。王某在酒后向郑某发送了多条露骨信息，其中一条写道："你比你师姐身材好，她去年主动来我房间，你想不想也试试？"

三位女演员已于昨日向电影局和相关纪检部门提交了正式举报信。电影局今日发布声明，称"已成立专项调查组，将对举报内容进行全面核实。如果属实，将依法依规严肃处理，绝不姑息"。

王某方面截至目前保持沉默，其手机已处于关机状态。其经纪公司发布声明称"正在了解情况，暂时无法回应"。

与此同时，王某已完成的最新电影《故园》原定下月上映，目前片方已紧急撤档。该片主演、多位知名演员先后发声支持三位举报人，称"为她们的勇敢点赞"。

法律专家指出，如果举报内容属实，王某不仅面临行业禁入，还可能涉嫌刑事犯罪。`,
    category: 'dujia-mengliao',
    categoryName: '独家猛料',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20dark%20movie%20set%2C%20clapperboard%20and%20camera%20equipment%2C%20dramatic%20red%20and%20amber%20lighting%2C%20mysterious%20sinister%20atmosphere%2C%20cinematic%20production%20environment%2C%20editorial%20photography&width=800&height=530&seq=article-10&orientation=landscape',
    author: '独家爆料组',
    date: '2026-06-27',
    readTime: '9分钟',
    views: 267000,
    likes: 12500,
    isHot: true,
    isExclusive: true,
    relatedIds: [4, 7, 12],
  },
  {
    id: 11,
    slug: 'chaohuo-zongyi-cizhi-yanyuan-quanbu',
    title: '爆款综艺突然停播，所有参演演员被紧急撤换，内幕惊人',
    summary: '年度爆款综艺《荒野求生记》突然宣布停播，原定的全部演员阵容被整体撤换，据传与投资方内部斗争有关。',
    content: `正在热播中的年度爆款综艺《荒野求生记》昨日突然宣布"无限期停播"，原定出演的六位明星全部被替换，这一突发事件引发全网热议。

《荒野求生记》自开播以来收视率一路飙升，每期节目播出后都能霸占热搜榜单，是平台今年最重磅的综艺项目。然而就在上周六最新一期播出后，官方账号突然删除了所有相关内容，并于昨日发布了停播公告。

公告仅称"因制作调整需要"，但对具体原因只字未提。这一反常举动立即引发各种猜测。

据知情人士爆料，停播的真正原因是投资方之间的内斗。该节目由两大资本方联合投资，A方为内容制作公司，B方为平台方。双方在利益分配、版权归属等问题上积怨已久。

"本来节目越火，双方矛盾越大。"知情人士称，"A方觉得B方在周边衍生、海外版权上赚的钱没分给自己，B方则嫌A方制作成本越来越高。上周终于撕破脸了，B方直接要求换制作团队。"

而演员的撤换则是另一个层面的问题。据悉，A方与六位参演艺人签的是独家约，B方无法在不支付高额违约金的情况下继续使用原班人马。因此干脆全部换掉，重新招募新阵容。

被撤换的艺人中最受伤的是正在上升期的演员马某。她原本指望靠这档综艺跻身一线，为此推掉了两部电视剧邀约。如今综艺停播，电视剧机会也已错过，"可以说是赔了夫人又折兵"。

平台方宣布，节目将以全新的制作团队和演员阵容重新启动，预计三个月后回归。但网友对此并不买账，"三个月后再看还会不会播出吧，这种内斗闹僵了，重启大概率遥遥无期"。

值得一提的是，该节目的冠名商已宣布暂停投放，待事态明朗后再做评估。而已经录制的三期内容据说"永久封存"，观众再也看不到了。`,
    category: 'mingxing-dongtai',
    categoryName: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Abandoned%20television%20studio%20set%20with%20empty%20chairs%20and%20deserted%20equipment%2C%20dusty%20surfaces%2C%20overhead%20lights%20turned%20off%2C%20lonely%20desolate%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20editorial%20photography&width=800&height=530&seq=article-11&orientation=landscape',
    author: '扒瓜小编',
    date: '2026-06-26',
    readTime: '5分钟',
    views: 134000,
    likes: 3210,
    isHot: true,
    isExclusive: false,
    relatedIds: [4, 9, 14],
  },
  {
    id: 12,
    slug: 'nanyan-yanyuan-jiubiao-nvyou-zhuangkuan',
    title: '男演员被曝同时交往五位女友，时间管理大师2.0版本',
    summary: '以"专情好男人"形象示人的男演员于某被五位女性同时爆料，详细的时间线整理显示其堪称"时间管理大师"。',
    content: `"好男人"人设再遭暴击！以"专情""深情"著称的男演员于某，被五位女性同时爆料其同时与多人交往，详细的时间管理"战绩"令人瞠目结舌。

于某，32岁，凭借多部甜宠剧中的"完美男友"角色走红，粉丝称其为"人间理想"。然而现实中的他， apparently 比剧中角色"精彩"得多。

第一位爆料人A女士称与于某自2023年1月起交往，直到看到热搜才知道自己不是唯一。"他跟我说在外地拍戏，不方便视频。结果另一个女生爆料说那段时间他每天都和她在一起。"

第二位爆料人B女士提供了更为详细的时间线。2024年情人节当天，于某上午与B女士共进午餐并赠送礼物，下午声称"要去见导演"，实际上赴了与C女士的约。晚上又赶到D女士家中过夜。"他把情人节过成了马拉松。"

第三位爆料人C女士晒出了于某给她的"专属日程表"——一份精心规划的Excel表格，标注了与每位女友见面、视频通话的时间窗口，甚至备注了"A爱吃辣、B不吃香菜、C过敏海鲜"等饮食偏好。

"最讽刺的是，表格最后一行写着'周二下午：独处充电'。"C女士苦笑，"后来我们才知道，那个'独处时间'其实是给E女士的。"

第四位爆料人D女士则提供了于某的"防查岗话术大全"：在拍戏时说"导演要求收手机"；在约会时说"手机没电了"；深夜消失时说"在背台词不能分心"。

第五位爆料人E女士身份最为特殊——她是于某的正牌未婚妻。"我们已经订婚了，婚期定在明年三月。"E女士说，"看到他给其他女生发的消息，内容和对我说的一模一样，连表情包都一样。"

五位女士在意识到彼此存在后建立了"受害者联盟"，共同整理了完整的时间线和证据链。她们表示将采取法律手段，追究于某在交往期间以"结婚"为名骗取财物的责任。

于某于昨日凌晨发布道歉声明，承认"在私人感情上处理不当"，但被网友批评为"避重就轻""没有诚意"。其代言的多个品牌宣布解约，待播剧集播出前景堪忧。`,
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20multiple%20chat%20conversations%20and%20calendar%20notifications%2C%20glowing%20screen%20in%20dark%20room%2C%20time%20management%20concept%2C%20digital%20overload%20aesthetic%2C%20editorial%20technology%20photography&width=800&height=530&seq=article-12&orientation=landscape',
    author: '扒瓜小编',
    date: '2026-07-02',
    readTime: '7分钟',
    views: 298000,
    likes: 15600,
    isHot: true,
    isExclusive: true,
    relatedIds: [1, 8, 10],
  },
  {
    id: 13,
    slug: 'tianhou-jieji-chongchu-dongjing',
    title: '天后级歌手沉寂三年后惊艳复出，东京演唱会座无虚席',
    summary: '华语乐坛天后林某在东京武道馆举办复出演唱会，沉寂三年后的首次公开演出状态惊人，全场座无虚席。',
    content: `暌违舞台三年的华语乐坛天后林某，昨晚在日本东京武道馆举办了盛大的复出演唱会。当晚全场座无虚席，更有大批中国歌迷专程飞往日本追星，场面极为壮观。

林某于2023年在事业巅峰期突然宣布"无限期退出娱乐圈"，此后没有任何公开活动，社交账号也停止更新。关于退出的原因众说纷纭，有人说是因为身体原因，有人说是为了家庭，还有人猜测与某段不为人知的感情有关。

昨晚的演唱会上，林某以一曲《如初》开场，清澈的嗓音瞬间将全场带入情绪高潮。三年的时间似乎没有在她身上留下任何痕迹，反而增添了更多沉淀后的力量感。

"这三年我没有停止唱歌，只是不再公开唱。"林某在talking环节透露，"我在家附近找了一个小录音棚，每天去唱一会儿。有时候唱给自己听，有时候唱给窗外的鸟听。"

演唱会中段，林某首次公开谈及退出的原因："那段时间我失去了声音。不是生理上的，是心理上的。我发现自己在舞台上越来越像个机器人，按程序走完流程，但内心是空的。我需要停下来，找回唱歌的意义。"

她提到这三年里去学习了茶道、插花和书法，"这些慢下来的事情让我明白，以前的生活太快了，快到来不及感受任何东西"。

演唱会安可环节，林某演唱了写给歌迷的新歌《谢谢你在》，唱到"谢谢你们还在"时几度哽咽。台下无数歌迷跟着泪崩，有粉丝举着"三年，一直在"的灯牌全场挥舞。

演唱会结束后，#林某复出#迅速登上微博热搜榜首，相关话题阅读量破5亿。多家音乐平台当晚紧急上架林某全部作品，播放量激增。

据经纪公司透露，林某接下来将启动亚洲巡回演唱会，首站已确定在台北小巨蛋。暌违三年的华语天后，正式宣告回归。`,
    category: 'mingxing-dongtai',
    categoryName: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Female%20singer%20performing%20on%20grand%20concert%20stage%2C%20dramatic%20spotlights%2C%20elegant%20red%20gown%2C%20passionate%20performance%20gesture%2C%20thousands%20of%20audience%20lights%20in%20background%2C%20cinematic%20concert%20photography&width=800&height=530&seq=article-13&orientation=landscape',
    author: '明星动态组',
    date: '2026-06-25',
    readTime: '5分钟',
    views: 145000,
    likes: 6780,
    isHot: false,
    isExclusive: false,
    relatedIds: [11, 14, 15],
  },
  {
    id: 14,
    slug: 'xinjin-yanyuan-xinpian-koubei-pengfang',
    title: '新晋演员首部电影口碑票房双爆，被誉为"十年一遇的天才"',
    summary: '24岁新人演员周某凭借电影《归途》一举成名，首周票房破3亿，豆瓣评分8.9，影评人盛赞其表演"令人窒息的真实"。',
    content: `24岁的周某，用一部《归途》让整个华语影坛为之震动。这部成本仅2000万的文艺片，首周票房突破3亿，豆瓣评分高达8.9，而最令人惊艳的，是首次担任主演的周某那令人窒息的表演。

《归途》讲述了一个农村青年在城市打工十年后决定返乡的故事。周某饰演的男主角阿强，从初到城市的青涩憧憬，到被现实磨砺后的麻木疲惫，再到最终决定回归乡土的释然，表演层次分明、收放自如。

"他的表演让我想起年轻时的梁朝伟。"著名影评人李某某在影评中写道，"那种眼神里的东西，不是靠技巧能练出来的，是天生的演员。"

更令人惊讶的是，周某并非科班出身。他原本是云南某县城的快递小哥，2022年在短视频平台偶然被导演相中，这才踏入演艺圈。《归途》是他第一次接触专业表演训练后的作品。

"导演说不要'演'，要把自己的经历放进去。"周某在首映礼上憨厚地笑道，"我就是这样过来的，十七岁到城里，送快递送了五年。所以拍的时候，不是在演，是在回忆。"

电影中最震撼的一场戏，是阿强在城市街头独自吃一碗面的长镜头。周某没有一句台词，只有埋头吃面、停顿、再吃的动作。但观众能清晰地感受到角色内心的全部情绪——疲惫、不甘、思念、认命。这个长达四分钟的镜头，被影评人称为"2026年华语电影最动人的四分钟"。

《归途》的成功引发了一场关于"素人演员"的讨论。有评论认为，专业院校出身的演员有时过于依赖技巧，反而失去了真实的生命力。周某的"非专业"恰恰成了他最大的优势。

目前，周某已收到超过20个剧本邀约，其中不乏大导演的大制作。但他表示短期内不想接太多工作："我想先回去看看爸妈，给他们讲讲故事里的我。"

这位"十年一遇的天才"，正以最朴素的方式开启他的演艺之路。`,
    category: 'mingxing-dongtai',
    categoryName: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20actor%20intense%20close%20up%20portrait%2C%20emotionally%20raw%20expression%2C%20dramatic%20side%20lighting%2C%20grainy%20film%20texture%2C%20cinematic%20atmosphere%2C%20warm%20tones%2C%20editorial%20portrait%20photography&width=800&height=530&seq=article-14&orientation=landscape',
    author: '明星动态组',
    date: '2026-06-24',
    readTime: '6分钟',
    views: 98000,
    likes: 4320,
    isHot: false,
    isExclusive: false,
    relatedIds: [11, 13, 15],
  },
  {
    id: 15,
    slug: 'guoji-yinghou-zhongguo-xingfei',
    title: '国际影后首次中国行引发全民追星热潮，三里屯交通瘫痪',
    summary: '好莱坞影后凯特·温斯莱特首次来华参加品牌活动，现身北京三里屯引发万人围观，现场交通一度瘫痪。',
    content: `好莱坞传奇影后凯特·温斯莱特昨日空降北京三里屯，为其代言的某奢侈品牌旗舰店开幕剪彩。这是她从业三十余年来首次到访中国大陆，消息一经传出，三里屯瞬间被热情的影迷围得水泄不通。

原定下午两点开始的活动，从上午十点起三里屯太古里周边就已聚集了大量粉丝。警方不得不临时封闭了部分路段，地铁十号线团结湖站也出现了罕见的客流拥堵。

下午两点三十分，凯特乘坐黑色商务车抵达现场。当她身着一袭深绿色丝绒长裙踏出车门时，现场爆发出震耳欲聋的欢呼声。五十八岁的凯特状态极佳，笑容温暖亲切，不断向人群挥手致意。

"她本人比银幕上更美，那种气质是照片无法传达的。"一位从广州专程飞来的粉丝激动地说，"我早上六点就来占位了，等了八个小时，值了！"

剪彩仪式上，凯特用不太流利但诚意满满的中文向在场观众问好："大家好，我很高兴来到中国。"她还特别提到自己是中餐的忠实爱好者，"我最喜欢宫保鸡丁，每次去伦敦的中国城都会吃"。

活动中，一位粉丝向凯特赠送了自己手绘的《泰坦尼克号》场景图。凯特感动地接过画作，当场给了这位粉丝一个拥抱，并用英文对她说："这幅画太美了，我会把它挂在家里。"

值得一提的是，凯特在媒体采访中主动提及了中国电影。"我看过很多中国电影，最近刚看了《归途》，那个年轻演员的表演令我印象深刻。"她笑着说，"如果有机会，我很想和中国导演合作。"

活动结束后，凯特并未立刻离开，而是在工作人员的陪同下走进太古里的一家北京烤鸭店。据店家透露，她一个人吃了半只烤鸭，还打包了三份鸭架带回酒店。

凯特的中国行将持续三天，接下来还将前往上海参加电影节活动。这位国际影后的首次中国之旅，无疑为中西方文化交流增添了浓墨重彩的一笔。`,
    category: 'mingxing-dongtai',
    categoryName: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20female%20celebrity%20on%20red%20carpet%2C%20green%20velvet%20gown%2C%20glamorous%20smile%2C%20paparazzi%20flashes%2C%20luxury%20event%20atmosphere%2C%20golden%20hour%20lighting%2C%20editorial%20fashion%20photography&width=800&height=530&seq=article-15&orientation=landscape',
    author: '明星动态组',
    date: '2026-06-23',
    readTime: '5分钟',
    views: 112000,
    likes: 5670,
    isHot: false,
    isExclusive: false,
    relatedIds: [13, 14, 11],
  },
];

export const hotComments = [
  {
    id: 1,
    username: '吃瓜群众一号',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20natural%20smile%2C%20casual%20style%2C%20warm%20soft%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '资深瓜友',
    rating: 5,
    content: '51扒瓜网的独家爆料从来没有让我失望过！每次爆料都有实锤，不是那种捕风捉影的谣言。特别是今天那个顶流小生的秘恋瓜，细节太真实了，连小区业主都出来作证，这瓜保熟！',
  },
  {
    id: 2,
    username: '八卦探测器',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20man%20with%20glasses%2C%20intellectual%20look%2C%20neutral%20expression%2C%20warm%20studio%20lighting%2C%20clean%20simple%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '三年老粉',
    rating: 5,
    content: '作为一个从51扒瓜网建站就开始关注的老粉，亲眼见证了这个网站的成长。内容越来越深度，爆料越来越有料，而且更新速度真的快，有时候半夜刷到新瓜的感觉不要太爽。',
  },
  {
    id: 3,
    username: '娱乐圈福尔摩斯',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20stylish%20young%20Chinese%20woman%2C%20confident%20expression%2C%20fashionable%20outfit%2C%20warm%20natural%20lighting%2C%20urban%20vibe%2C%20editorial%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '推理达人',
    rating: 5,
    content: '最喜欢51扒瓜网文章的逻辑性，每个爆料都有完整的时间线和证据链。不像其他营销号只会搬运，这里是真的在做深度挖掘。特别是那个导演性骚扰的系列报道，系统性整理了很多零散的线索。',
  },
  {
    id: 4,
    username: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20relaxed%20young%20Chinese%20man%20casual%20outfit%2C%20slight%20smile%2C%20evening%20warm%20lighting%2C%20cozy%20atmosphere%2C%20lifestyle%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '夜猫子瓜友',
    rating: 4,
    content: '每天晚上睡前必刷51扒瓜网，已经是我的固定仪式了。界面清爽，加载速度快，文章排版也很舒服。唯一的建议是希望能增加评论区互动功能，想和其他瓜友一起讨论！',
  },
  {
    id: 5,
    username: '理性吃瓜派',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20mature%20Chinese%20woman%20professional%20look%2C%20thoughtful%20expression%2C%20soft%20natural%20lighting%2C%20clean%20neutral%20background%2C%20business%20casual%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    role: '理性分析党',
    rating: 5,
    content: '在娱乐八卦网站里，51扒瓜网算是最有底线的一个了。虽然报道劲爆内容，但不会为了流量制造虚假信息，也不会过度侵犯隐私。很多文章最后都会呼吁理性看待，这点很难得。',
  },
  {
    id: 6,
    username: '瓜田里猹',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20playful%20young%20Chinese%20woman%20laughing%2C%20energetic%20expression%2C%20bright%20warm%20lighting%2C%20colorful%20casual%20style%2C%20fun%20personality%20headshot&width=100&height=100&seq=avatar-06&orientation=squarish',
    role: '新瓜友',
    rating: 4,
    content: '刚发现这个宝藏网站不到一个月，已经安利给整个办公室的同事了。以前刷微博找瓜要翻半天，现在直接来51扒瓜网，所有热门瓜都在这里整理好了，省时省力！',
  },
];